import I18n from 'I18n';
import { keyToNavData } from 'developer-docs-shared-components/config/navData/keys';
import { navigation } from 'developer-docs-source/navigation';
import memoize from 'react-utils/memoize';
import { PageTypes, Paths } from '../../../components/RoutesPublic';
import { overrideLabelOnItemAndCheckBadge } from '../navUtils';

/**
 * 'API and Reference' > 'CMS Reference' secondary nav config.
 */
export const cmsReferenceNavConfig = memoize(() => {
  const commonPath = `${Paths.REFERENCE}/cms`;
  const nav = navigation[commonPath];
  const cmsReferenceNavData = keyToNavData[commonPath];
  const navigationItems = nav.items.map(item => {
    return overrideLabelOnItemAndCheckBadge(item, cmsReferenceNavData, commonPath);
  });
  const config = {
    locatorPageType: PageTypes.REFERENCE,
    sectionLabel: I18n.text('developer-docs-ui.navigation.reference.cmsReference'),
    commonPath,
    items: navigationItems
  };
  return config;
});